export default __webpack_public_path__ + "static/media/letters.dd1dac7a.png";